import React, { useContext, useRef } from "react";
import PropTypes from "prop-types";
import { AppStoreContext } from "../stores/AppStore";
import { useTranslation } from "react-i18next";
import "./Register.css";

export const ModalLink = props => {
  const [t] = useTranslation();

  const linkRef = useRef();

  const { text, name } = props;

  const appStore = useContext(AppStoreContext);

  const showModal = e => {
    e.stopPropagation();
    e.preventDefault();

    const whichModal = linkRef.current.getAttribute("data-name");
    const desiredLocale = (appStore.locale || "en")
      .toLowerCase()
      .substring(0, 2);
    const locale =
      ["de", "en", "ja", "ko", "zh"].find(
        supported => supported === desiredLocale
      ) || "en";

    switch (whichModal) {
      case "confidentiality_agreement":
        appStore.modalTitle = t("confidentiality_agreement");

        appStore.iframeUrl = `locales/${locale}/confidentiality-agreement.html`;
        break;
      default:
        console.log("default");
        break;
    }

    appStore.showModal = true;
  };

  return (
    <span className="link" ref={linkRef} onClick={showModal} data-name={name}>
      {text}
    </span>
  );
};

ModalLink.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default ModalLink;
